module.exports = __webpack_public_path__ + "img/expand-icon.057e919c.svg";